import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './index.css';

// DOM elements
const rootElement = document.getElementById('root');

// Verify the root element exists
if (!rootElement) {
  throw new Error('Failed to find the root element');
}

// Create root and render
const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
